const onResizeDelay = 100;

let onResizeTimer: NodeJS.Timeout;

type TopEvent = Event & { topEvent: { widthDiff: number, hightDiff: number } }

/**
 * Установленные обрабочики на событие изменения размеров окна
 */
const onResizeListeners: Map<(ev: TopEvent) => any, (ev: TopEvent) => any> = new Map();

// зафиксированное состояние размеров окна
const windowSize = {
	width: window.innerWidth,
	height: window.innerHeight,
};

/**
 * Добавить обработчик на событие изменения размеров экрана
 * вызов таких обработчиков будет опмизирован и объединен в одно событие
 */
function addOnReize (listener: (this: Element, ev: TopEvent) => any) {
	onResizeListeners.set(listener, listener);
}

/**
 * Удаление обработчика на событие изменений размеров экрана
 */
function removeOnResize (listener: (this: Element, ev: TopEvent) => any) {
	onResizeListeners.delete(listener);
}

function onResize (e: any) {
	clearTimeout(onResizeTimer);

	onResizeTimer = setTimeout(function () {
		e.topEvent = {
			widthDiff: windowSize.width - window.innerWidth,
			hightDiff: windowSize.height - window.innerHeight,
		};

		windowSize.width = window.innerWidth;
		windowSize.height = window.innerHeight;

		onResizeListeners.forEach((callback) => callback(e));
	}, onResizeDelay);
}

window.addEventListener('resize', onResize);

export default {
	addOnReize,
	removeOnResize,
};
